export const IconTrash = ({ className }: { className?: string }) => (
  <svg className={`fill-current ${className}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 6.0014H16V4.3314V4.3314C15.9512 2.9985 14.833 1.95641 13.5 2.0014H10.5V2.0014C9.16696 1.95642 8.04885 2.9985 8 4.3314V6.0014H3C2.44771 6.0014 2 6.44912 2 7.0014C2 7.55369 2.44771 8.0014 3 8.0014H4V19.0014C4 20.6583 5.34315 22.0014 7 22.0014H17C18.6569 22.0014 20 20.6583 20 19.0014V8.0014H21C21.5523 8.0014 22 7.55369 22 7.0014C22 6.44912 21.5523 6.0014 21 6.0014ZM10 4.33C10 4.17 10.21 4 10.5 4H13.5C13.79 4 14 4.17 14 4.33V6H10V4.33ZM18 19C18 19.5523 17.5523 20 17 20H7C6.44771 20 6 19.5523 6 19V8H18V19Z"
    />
  </svg>
)
